// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loading":"Loader_loading__BtKRp","entry":"Loader_entry__YRo-C"};